import React, { useCallback } from "react";
import * as THREE from 'three';
import MLeg from '../marker/mLeg';
import MSocketLoad from '../marker/mSocketLoad';

import { Lines } from "../shape/Line";

import MMeasure from '../marker/mMeasure';
import MStandard from '../marker/mStandard';

import Control from '../store/control';
import Param from '../store/param';


const MarkingStandard = () => {
  const activeStep         = Param.Get("activeStep");
  
  const prosthetics        = Control.Get('prosthetics');
  const showLeg            = Control.Get("showLeg");
  const showSocket         = Control.Get("showSocket");
  const wireLeg            = Control.Get("wireLeg");
  const transparentLeg     = Control.Get("transparentLeg");
  const wireSocket         = Control.Get("wireSocket");
  const meshLeg            = Control.Get("meshLeg");
  const meshSocketLoad         = Control.Get("meshSocketLoad");

  const flgLegClickable    = Control.Get("flgLegClickable");
  const flgSocketClickable = Control.Get("flgSocketClickable");
  const currentAngle       = Control.Get("currentAngle");
  const measure            = Control.Get('measure');

  const standardGeometry   = Control.Get('standardGeometry');

  
  var opacityLeg = 0;
  const opacity = (showLeg) ? 0.8 : 0.8;
  (activeStep>=3)? opacityLeg = 0.4 : opacityLeg = 1;
  
  const isMeasure   = measure;
  const isLeg       = meshLeg && showLeg;
  
  const isSocket    = meshSocketLoad && typeof standardGeometry === 'undefined' && showSocket;

  const isStandard = typeof standardGeometry !== 'undefined' && showSocket;

  return (
    <>
      { isMeasure ? <MMeasure
                      angle = {currentAngle}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                      /> : null }

      { isSocket  ? <MSocketLoad
                      meshSocketLoad={meshSocketLoad}
                      clickable={flgLegClickable} 
                      showWire={wireLeg}
                      showTransparent={transparentLeg}
                      fileExt={0}
                      color={'dodgerblue'}
                    /> : null }
      
      { isStandard ? <MStandard 
                      standardGeometry = {standardGeometry}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null}
    </>
  );
};

export default MarkingStandard;
